import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {
        },
        beforeNextStep: function() {
        },
        title: "__address_length_months_current__",
        fields: [
            {
                // label: 'Time At Address',
                name: 'address_length_months',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            var options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    {

        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                // label: 'Are you a homeowner?',
                name: 'own_home',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            var options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__living_situation__",
        fields: [
            {
                label: '__rent_mortgage_payment__',
                name: 'rent_mortgage_payment',
                placeholder: '1400',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 6
                },
            },
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
        ],
        hideIfCondition: (app) => {
            var options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || options.includes(app.address.province);
        }
    },
    {
        loadingFunction: (app) => {
            let isFlinks = app && app.completed_flinks && app.completed_flinks == 'yes';
            if( !isFlinks ) {
                return false;
            }

            return [
                {
                    seconds: 3,
                    message: '<h3 class="my-4 text-center h4 text-muted">Finalizing results...</h3>'
                },
            ];
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                // label: 'Citizenship Status',
                name: 'canadian_status',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__ Resident", "value":"pr" },
                    { "text":"__opt_cs_work__ Permit", "value":"work_permit" },
                    { "text":"__opt_cs_student__ Visa", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // debt amounts
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__credit_card_debt_amount__",
        fields: [
            {
                // label: 'Credit Card Debt Amount',
                name: 'cc_debt_amount',
                placeholder: '2500',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_5000_less__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                ]
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !!app.cc_debt_amount;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "Total Other Unsecured Debt",
        textTop: "__unsecured_debt_amount_definition__",
        fields: [
            {
                // label: 'Total Other Unsecured Debt',
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_5000_less__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                ]
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return !!app.unsecured_debt_amount;
        }
    },
    // ends debt amounts
    {
        beforeCreate: function(app) {
            return !!app.opt_in ? 'executeEarlySubmitApplication' : false;
        },
        // beforeCreate: function() {},
        // beforeNextStep: 'executeSubmitApplication',
        beforeNextStep: function(app) {
            return !app.opt_in ? 'executeSubmitApplication' : false;
        },
        title: "__is_last_step__",
        // textTop: `<p class="text-muted h5 my-3 text-center">Are you ready to receive your recommendations by electronic messages and see your loan options?</p>`,
        textTop: (app) => {
            return !app.opt_in
                ? "__get_options_with_consent__"
                : '';
        },
        fields: [
            {
                label: false,
                name: 'options_opt_in',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text": "__opt_continue_with_consent_yes__", "value":'yes', "btnClass":"btn-primary" },
                    { "text": "__opt_continue_with_consent_no__", "value":'no' },
                ]
            }
        ],
        textBottom: (app) => {
            var consentText = "__consent_text__";
            var optInText = !app.opt_in
                ? "__opt_in_text__"
                : '';

            // return fieldConditionHelper.hasAuthConsent(app) ? optInText : (consentText + optInText);
            return optInText;
        },
        hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     return !!app.opt_in;
        // }
    },
];

export default steps;
